import { Button } from "@vitalsource/vstui";
import { createThemedComponent } from "@vitalsource/vstui/themes";
import React from "react";
import { BAR_HEIGHT } from "./vars";
import { FaceSad } from "@vitalsource/vstui-icons";
import { withAllMatches } from "../../../ui/components/mediaquery/breakpoints";

const bg = props => props.theme.vstui.color.primary.getShade(6);

const ThemedButton = createThemedComponent(Button, {
  Button_minHeight_medium: BAR_HEIGHT,
  Button_minHeight_small: BAR_HEIGHT,
  Button_fontSize_medium: 16,
  Button_paddingHorizontal_withIconMedium: "32px",
  Button_paddingHorizontal_withIconSmall: "16px",
  Button_borderRadius: 0,
  Button_backgroundColor_themePrimary: bg,
  Button_backgroundColor_themePrimary_hover: bg
});

function ReCenterButton({ onClick, isSmall }) {
  const text = i18n.t("tts.re-center");
  const label = isSmall ? text : null;
  const content = isSmall ? undefined : text;

  return (
    // TODO: Real Icon https://github.com/vitalsource/vstui/pull/279
    <ThemedButton
      iconStart={<FaceSad />}
      onClick={onClick}
      label={label}
      size={isSmall ? "small" : "medium"}
    >
      {content}
    </ThemedButton>
  );
}

export default withAllMatches(ReCenterButton);
